/* eslint-disable no-proto */
;(function() {
  if (!(Object.setPrototypeOf || {}.__proto__)) {
    const nativeGetPrototypeOf = Object.getPrototypeOf

    Object.getPrototypeOf = function(object) {
      if (object.__proto__) {
        return object.__proto__
      }
      return nativeGetPrototypeOf.call(Object, object)
    }
  }
})()
